import { withRouter } from "react-router";
import { Badge, BlockStack, Button, ButtonGroup, Card, Page, Text } from "@shopify/polaris";
import Switch from "react-switch";
import "./index.scss";
import Langauge from "../../../i18n/Language";
import { useEffect, useState } from "react";
import {
    reqGetHtmlSitemapData,
    reqUpdateHTMLSitemap,
    reqGetLLMSData,
    reqUpdLLMSSwitch,

} from "../../../api";
import UpgradeSingleIcon from "../../../components/UpgradeSingleIcon";

const t = Langauge;

const CrawlingIndexing = (props) => {
    const {
        history,
        level,
        domain,

    } = props;

    const [sitemapOn, setSitemapOn] = useState(false);
    const [siteUrl, setSiteUrl] = useState('');
    const [checkLoading, setCheckLoading] = useState(true);
    const [lastUpdateTime, setLastUpdateTime] = useState(0);
    const [llmsOn, setLlmsOn] = useState(false);
    const [llmsLoading, setLlmsLoading] = useState(true);
    const [llmsUpdateTime, setLlmsUpdateTime] = useState(0);
    const [userLevel, setUserLevel] = useState(level);
    const [userDomain, setUserDomain] = useState(domain);

    const handleSettingClick = (type) => {
        if (type === 'htmlSitemap') {
            history.push('/technicalSEO/html-sitemap');
        } else if (type === 'instantIndexing') {
            history.push('/technicalSEO/instant-index');
        } else if (type === 'llmsTxt') {
            history.push('/technicalSEO/llms-txt');
        }
    };

    // 更新HTML Sitemap数据
    const updateSitemapData = async () => {
        setCheckLoading(true);
        setSitemapOn(!sitemapOn);
        const params = {
            sitemapOn: Number(!sitemapOn)
        };
        const res = await reqUpdateHTMLSitemap(params);
        if (res.code === "200") {
            props.toggleToast(res.msg);
        } else {
            setSitemapOn(!sitemapOn);
            props.toggleToast(res.msg, true);
        }

        setCheckLoading(false);
    };

    // 获取用户设置的数据
    const getStructuredData = async () => {
        const res = await reqGetHtmlSitemapData();
        if (res.ack === 1) {
            setCheckLoading(false);
            setSiteUrl(res.data.htmlSitemapUrl);
            setSitemapOn(res.data.HTMLSitemap.status);
            setLastUpdateTime(res.data.lastUpdate);
        } else {
            props.toggleToast(res.msg, true);
        }
    }

    // 打开HTML Sitemap页面
    const htmlSitemapUrl = () => {
        window.open(`https://${siteUrl}`)
    }

    // 打开 llms.txt 预览
    const previewLlmsTxt = () => {
        window.open(`https://${userDomain}/llms.txt`);
    }

    // 获取llms.txt数据
    const getLlmsTxtData = async () => {
        const res = await reqGetLLMSData();
        if (res.ack === 1) {
            props.getPageDataRedux(res, 'llmsTxt');
            setLlmsOn(Boolean(res.data.switch));
            setLlmsUpdateTime(res.data.update_at);
        }

        setLlmsLoading(false);
    }

    // 切换llms.txt开关
    const handleLlmsSwitch = async () => {
        if (userLevel === 1 && !llmsOn) {
            props.upgradeModal(1, 'LLmsTxt', 'llms_txt');
            return;
        }
        setLlmsOn(!Boolean(llmsOn));
        setLlmsLoading(true);
        const params = {
            switch: Number(!llmsOn)
        };
        const res = await reqUpdLLMSSwitch(params);
        if (res.ack === 1) {
            if (res.code === 201) {
                // 进入详情页
                history.push('/technicalSEO/llms-txt');
            }
        } else {
            props.toggleToast(t(res.msg), true);
            setLlmsOn(!Boolean(llmsOn));
        }

        setLlmsLoading(false);
    }

    useEffect(() => {
        setUserLevel(level);
    }, [level]);

    useEffect(() => {
        setUserDomain(domain);
    }, [domain]);

    useEffect(() => {
        getStructuredData();
        getLlmsTxtData();
    }, []);

    return (
        <div className="ai_blog_generator_pages">
            <Page>
                <title>SEOWILL - Crawling & Indexing</title>

                <BlockStack gap={400}>
                    <Card padding={0}>
                        {/* HTML Sitemap Card */}
                        <div className="crawling_indexing_card html_sitemap_card">
                            <div className="crawling_indexing_image_wrapper">
                                <img
                                    src={"/imgs/indoorImg/new/HTMLSitemapHalf.png"}
                                    alt=""
                                    className="crawling_indexing_preview_image"
                                />
                            </div>
                            <div className="crawling_indexing_card_info">
                                <BlockStack gap={100}>
                                    <div className="crawling_indexing_card_header">
                                        <Text variant="headingMd" as="h2" fontWeight="semibold">
                                            {t("HTML Sitemap")}
                                        </Text>
                                        <Badge tone={sitemapOn ? 'success' : ''}>{sitemapOn ? t("On") : t("Off")}</Badge>
                                    </div>
                                    <Text variant="bodyMd" as="p" tone="subdued">
                                        {t("Create a sitemap page to browse all your pages and help search engines better understand your site structure.")}
                                    </Text>
                                    <span style={{ color: "#616161" }}>{t("Last updated")}: {lastUpdateTime ? formatUSATime(lastUpdateTime) : '-'}</span>
                                </BlockStack>
                                <ButtonGroup>
                                    <Button
                                        onClick={() => handleSettingClick('htmlSitemap')}
                                    >
                                        {t("Setting")}
                                    </Button>
                                    {
                                        (sitemapOn && !checkLoading) && <Button
                                            onClick={() => htmlSitemapUrl()}
                                            disabled={!siteUrl}
                                        >
                                            {t("Preview")}
                                        </Button>
                                    }
                                </ButtonGroup>
                            </div>
                            <div className='html_switch_indoor'>
                                <span>{checkLoading && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem' }} alt="loading" />}</span>
                                <Switch disabled={checkLoading} onChange={() => updateSitemapData('statusOperate')} checked={Boolean(sitemapOn)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                            </div>
                        </div>
                    </Card>

                    <Card padding={0}>
                        {/* llms.txt Card */}
                        <div className="crawling_indexing_card llms_txt_card">
                            <div className="crawling_indexing_image_wrapper">
                                <img
                                    src={"/imgs/indoorImg/new/llms.png"}
                                    alt=""
                                    className="crawling_indexing_preview_image"
                                />
                            </div>
                            <div className="crawling_indexing_card_info">
                                <BlockStack gap={100}>
                                    <div className="crawling_indexing_card_header">
                                        <Text variant="headingMd" as="h2" fontWeight="semibold">
                                            {t("llms.txt")}
                                        </Text>
                                        {userLevel === 1 ? <UpgradeSingleIcon type="LLmsTxt" site="llms_txt" upgradeModal={props.upgradeModal} /> : null}
                                        <Badge tone={llmsOn ? 'success' : ''}>{llmsOn ? t("On") : t("Off")}</Badge>
                                    </div>
                                    <Text variant="bodyMd" as="p" tone="subdued">
                                        {t("Generate a llms.txt file to help AI Chats understand your store and recommend your products in their answers.")}
                                    </Text>
                                    {
                                        (llmsOn && !llmsLoading) ? <span style={{ color: "#616161" }}>{t("Last updated")}: {llmsUpdateTime ? formatUSATime(llmsUpdateTime) : '-'}</span> : null
                                    }
                                </BlockStack>
                                <ButtonGroup>
                                    <Button onClick={() => handleSettingClick('llmsTxt')}>
                                        {t("Customize")}
                                    </Button>
                                    {
                                        (llmsOn && !llmsLoading) && <Button
                                            onClick={() => previewLlmsTxt()}
                                            disabled={!userDomain}
                                        >
                                            {t("Preview")}
                                        </Button>
                                    }
                                </ButtonGroup>
                            </div>
                            <div className='html_switch_indoor'>
                                <span>{llmsLoading && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem' }} alt="loading" />}</span>
                                <Switch disabled={llmsLoading || (userLevel === 1 && !Boolean(llmsOn))} onChange={() => handleLlmsSwitch()} checked={Boolean(llmsOn)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                            </div>
                        </div>
                    </Card>

                    <Card padding={0}>
                        {/* Instant Indexing Card */}
                        <div className="crawling_indexing_card instant_indexing_card">
                            <div className="crawling_indexing_image_wrapper">
                                <img
                                    src={"/imgs/indoorImg/new/InstantIndexing.png"}
                                    alt="Instant Indexing Preview"
                                    className="crawling_indexing_preview_image"
                                />
                            </div>
                            <div className="crawling_indexing_card_info">
                                <BlockStack gap={100}>
                                    <div className="crawling_indexing_card_header">
                                        <Text variant="headingMd" as="h2" fontWeight="semibold">
                                            {t("Instant Indexing")}
                                        </Text>
                                        {userLevel === 1 ? <UpgradeSingleIcon type="InstantIndex" site="instant_index" upgradeModal={props.upgradeModal} /> : null}
                                    </div>
                                    <Text variant="bodyMd" as="p" tone="subdued">
                                        {t("Submit your pages directly to Google for faster indexing and quicker visibility in search results.")}
                                    </Text>
                                </BlockStack>
                                <div className="crawling_indexing_card_actions">
                                    <Button
                                        onClick={() => handleSettingClick('instantIndexing')}
                                    >
                                        {t("Submit")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </BlockStack>
            </Page>

        </div>
    );
};

// 格式化时间戳
function formatUSATime(time) {
    // 创建一个新的 Date 对象，传入时间戳（秒为单位）
    var date = new Date(time * 1000);

    // 定义月份名称
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // 提取年、月、日、小时、分钟、上午/下午
    var year = date.getFullYear();
    var month = monthNames[date.getMonth()];
    var day = date.getDate();

    // 组合成指定格式的字符串
    var formattedDate = t(month) + ', ' + (day < 10 ? '0' + day : day) + ', ' + year;
    return formattedDate;
}

export default withRouter(CrawlingIndexing);